// 0：APP未扫码
// 1: APP已经扫码
// 3: APP取消扫码登录
// 100：APP扫码登录成功
export const QR_CODE_STATUS_UNSANED = 0;
export const QR_CODE_STATUS_SCANED = 1;
export const QR_CODE_STATUS_CANCELED = 3;
export const QR_CODE_STATUS_SUCCESS = 100;

export const NVC_ERROR_CODE = '30011';

export const NVC_LANGUAGES = [
  'cn',
  'zh_CN',
  'tw',
  'en',
  'en_US',
  'ar_SA',
  'de_DE',
  'es_ES',
  'fr_FR',
  'in_ID',
  'it_IT',
  'iw_HE',
  'ja_JP',
  'ko_KR',
  'nl_NL',
  'pt_BR',
  'ru_RU',
  'th_TH',
  'tr_TR',
  'vi_VN'
];
